<template>
  <div v-if="me">
    <v-chip v-if="me.staging" color="warning" class="mr-3">
      Staging
    </v-chip>
    <v-menu min-width="450" max-width="450" open-on-hover dark offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="rounded-lg" outlined dark v-on="on" v-bind="attrs">
          <v-icon>mdi-view-grid</v-icon>
        </v-btn>
      </template>
      <v-card class="rounded-lg">
        <v-card-text>
          <v-row>
            <v-col
              :cols="isOutstaff ? 8 : 4"
              class="pa-1"
              v-for="(link, index) in activeLinks"
              :key="index"
            >
              <v-card
                outlined
                min-height="100%"
                light
                class="rounded-lg d-flex"
                style="cursor: pointer;"
              >
                <v-card-text
                  class="text-center px-1"
                  @click="navigateTo(link.system)"
                >
                  <v-icon class="mb-1">{{ link.icon }}</v-icon>
                  <br />
                  <small>{{ link.name }}</small>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pa-1">
              <v-card
                @click="logout()"
                outlined
                min-height="100%"
                color="error"
                class="rounded-lg"
              >
                <v-card-text class="text-center">
                  <v-icon class="mb-1">mdi-logout</v-icon>
                  <br />
                  <small>Logout</small>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavigationMenu",
  props: ["currentSystem"],
  data() {
    return {
      links: [
        {
          system: "case",
          name: "Cases",
          restricted: false,
          outstaff: false,
          icon: "mdi-clipboard-plus-outline",
        },
        {
          system: "client",
          name: "Clients",
          restricted: false,
          outstaff: false,
          icon: "mdi-hospital-box",
        },
        {
          system: "customer_service",
          name: "Customer Service",
          restricted: false,
          outstaff: false,
          icon: "mdi-face-agent",
        },
        {
          system: "newCheckin",
          name: "Checkin",
          restricted: false,
          outstaff: false,
          icon: "mdi-inbox-arrow-down",
        },
        {
          system: "design",
          name: "Design",
          restricted: false,
          outstaff: true,
          icon: "mdi-pencil-ruler",
        },
        {
          system: "production",
          name: "Production",
          restricted: false,
          outstaff: false,
          icon: "mdi-factory",
        },
        {
          system: "finishing",
          name: "Finishing",
          restricted: false,
          outstaff: false,
          icon: "mdi-beaker-outline",
        },
        {
          system: "warehouse",
          name: "Warehouse",
          restricted: false,
          outstaff: false,
          icon: "mdi-inbox",
        },
        {
          system: "accounts",
          name: "Accounts",
          restricted: true,
          outstaff: false,
          icon: "mdi-bank",
        },
        {
          system: "gauge_manufacturing",
          name: "Gauge MRP",
          restricted: true,
          outstaff: false,
          icon: "mdi-package-variant-closed",
        },
        {
          system: "management",
          name: "Management",
          restricted: true,
          outstaff: false,
          icon: "mdi-lock",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["me"]),
    activeSystem() {
      return this.links.findIndex((link) => link.system === this.currentSystem);
    },
    activeLinks() {
      let links = this.links;

      if (this.restricted)
        links = this.links.filter((link) => !link.restricted);

      if (this.isOutstaff) links = this.links.filter((link) => link.outstaff);

      return links;
    },
    restricted() {
      return this.me?.restricted;
    },
    isOutstaff() {
      return this.me?.all_departments?.includes("OUTSTAFF");
    },
  },
  methods: {
    navigateTo(system) {
      if (system === "newCheckin")
        return (document.location = "/clients/checkin");
      document.location = `${system}.html`;
    },
    logout() {
      document.location = "/oauth2/logout/";
    },
  },
};
</script>
